/** @format */
import {
    ChoiceChip,
    ChoiceChipVariant,
} from '@mpb-com/feather/components/atoms/choice-chip';
import React, { ChangeEvent, FunctionComponent } from 'react';

import { handleAccessorySelect, isAccessorySelected } from './helpers';
import { AccessoryOptionProps } from './types';

export const AccessoryOption: FunctionComponent<AccessoryOptionProps> = ({
    option,
    onAccessorySelect,
    selectedOptions,
}) => {
    if (!option) {
        return null;
    }

    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        handleAccessorySelect(
            option.label,
            option.value,
            event.target.checked,
            onAccessorySelect,
            selectedOptions
        );
    };

    return (
        <ChoiceChip
            key={option.value}
            variant={ChoiceChipVariant.CHECKBOX}
            name={option.label}
            value={option.value.toString()}
            checked={isAccessorySelected(option.value, selectedOptions)}
            onChange={handleOnChange}
        >
            {option.label}
        </ChoiceChip>
    );
};
